// Automatically open print dialog after loading the print view 
const init = () => {
    if ( window.location.search.match('view=print') ) {
        window.setTimeout( window.print, 1500 );
    }
};

export default {
    init
};